<script>
	import Img from "./Img.svelte" 
  import format from "number-format.js"; 
  export let items;  
</script> 
<style>
   :global(.svelte-image-loader) {
    background-color: #aaaaaa;
    min-height: 175px;
    position: relative;
  }
</style> 
  {#each items as a, i}
    <a class="block w-1/2 lg:w-1/5 md:w-1/3 sm:w-1/3" href="product/{a.alias}-{a.ID}">
      <div class="p-1 md:p-2">
        <div
          class="flex flex-col items-center justify-center flex-grow overflow-hidden bg-white rounded-lg shadow-md hover:shadow-lg">
          <figure class="w-full">
            {#if a.pictures.length > 0}
            {#each a.pictures as p}
              {#if p.statusPic ==="1"}
              <Img id="{a.alias}" css="mx-auto block w-full" datasrc="https://pics.dekatan.com/{p.fileName}" alt="{a.alias}" />
                {/if}
              {/each}
              {:else}  
              <img width="600" height="600"
              id="{a.alias}" class="block w-full mx-auto transition-opacity duration-500 ease-linear"
d alt="{a.alias}" src="data:image/svg+xml;charset=UTF-8,%3Csvg%20width%3D%22600%22%20height%3D%22600%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20600%20600%22%20preserveAspectRatio%3D%22none%22%3E%0A%20%20%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%20type%3D%22text%2Fcss%22%3E%0A%20%20%20%20%20%20%20%20%20%20%23holder%20text%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20fill%3A%20%23eeeeee%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-family%3A%20sans-serif%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-size%3A%2050px%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20font-weight%3A%20200%3B%0A%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%3C%2Fstyle%3E%0A%20%20%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%20%20%3Cg%20id%3D%22holder%22%3E%0A%20%20%20%20%20%20%20%20%3Crect%20width%3D%22100%25%22%20height%3D%22100%25%22%20fill%3D%22%23fafafa%22%3E%3C%2Frect%3E%0A%20%20%20%20%20%20%20%20%3Cg%3E%0A%20%20%20%20%20%20%20%20%20%20%3Ctext%20text-anchor%3D%22middle%22%20x%3D%2250%25%22%20y%3D%2250%25%22%20dy%3D%22.3em%22%3E%5B%20dekatan%20%5D%3C%2Ftext%3E%0A%20%20%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%20%20%3C%2Fg%3E%0A%20%20%20%20%3C%2Fsvg%3E"/> 
              {/if}

          </figure>
          <footer class="flex flex-col justify-center w-full p-3 ">
            <h3 title="{a.name}"
              class="mb-2 text-xs lg:text-base lg:font-normal ellipsis-2">
              {a.name}
            </h3>
            <h3 class="mb-2 text-xs font-semibold text-orange-700 lg:text-sm">{format( "Rp #.###,", a.price)},-</h3>
            <p class="hidden text-xs font-thin text-gray-700 lg:text-sm lg:block ellipsis-2">
              {a.shop.location}
            </p>
          </footer>
        </div>
      </div>
      <div class="clearfix"></div>
    </a>
  {/each}
